import { render, staticRenderFns } from "./AlertasBarredores.vue?vue&type=template&id=1bba063c&scoped=true&"
import script from "./AlertasBarredores.vue?vue&type=script&lang=ts&"
export * from "./AlertasBarredores.vue?vue&type=script&lang=ts&"
import style0 from "./AlertasBarredores.vue?vue&type=style&index=0&id=1bba063c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bba063c",
  null
  
)

export default component.exports